import React from 'react';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { Button, Icon } from '@tcc/crate';

const OverlayQuickLayerSelect = ({
  menuOptions,
  scriptType,
  selectedLayer,
  onChangeOverlay,
  setIsModalActive
}) => {
  const baseClass = 'vra-layer-quick-maps-menu';
  const displayList = [];
  // Manually insert a "more" option to the end
  const more = { layer: 'more', season: '' };
  [...menuOptions, more ].forEach( ({ layer, layerGroup, season, overlayUuid: uuid }) => {
    const isSelected = layer === selectedLayer;
    const linkClassString = classNames({
      [`${baseClass}__menu-option-link`]: true,
      [`${baseClass}__menu-option-link--selected`]: isSelected
    });
    const menuOptionClassString = classNames({
      [`${baseClass}__menu-option`]: true,
      [`${baseClass}__menu-option--more`]: layer === 'more' // hardcoded
    });
    const linkClassSubtitleString = classNames({
      [`${baseClass}__menu-option-link-subtitle`]: true
    });
    displayList.push(
      <Button
        className={menuOptionClassString}
        key={`${baseClass}__menu-option-${layer}`}
        mode='link'
        onClick={
          () => {
            onChangeOverlay({ layer, layerGroup, season, uuid });
            if ( layer === 'more' ) {
              setIsModalActive(true);
            }
          }
        }
        testId='map-options'
      >
        <span
          className={linkClassString}>
          { getMessage(`button-text__layer-selection--${layer}`, { scriptType }) }
          { ` ${season || ''}` }
        </span>
        <span
          className={linkClassSubtitleString}>
          { getMessage(`label-text__${layer}`) }
        </span>
        { isSelected && (
          <Icon className={`${baseClass}__menu-option-check-mark`} glyph={Icon.set.CHECK} />
        )}
      </Button>
    );
  });

  return (
    <div>
      {displayList}
    </div>
  );
};

OverlayQuickLayerSelect.propTypes = {
  menuOptions: propTypes.arrayOf(propTypes.shape({
    layer: propTypes.string.isRequired,
    overlayUuid: propTypes.string.isRequired,
    season: propTypes.string,
    cropId: propTypes.number,
    crop: propTypes.string
  })),
  onChangeOverlay: propTypes.func.isRequired,
  scriptType: propTypes.string.isRequired,
  selectedLayer: propTypes.string,
  setIsModalActive: propTypes.func.isRequired
};

export default OverlayQuickLayerSelect;
